/**
 * Derive a workspace slug from a display name, matching the shared
 * `TenantSlugSchema` shape (`src/shared/tenants.ts`): lowercase, starts/ends
 * alphanumeric, hyphens inside, max 64 chars. The derived slug is validated
 * against that shared schema before submit, so a mismatch fails locally and
 * loudly rather than as a server round-trip.
 */
export function slugifyWorkspaceName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+/, '')
    .slice(0, 64)
    .replace(/-+$/, '');
}
